module.exports = __webpack_public_path__ + "media/images/logos/windeurope-tech2022-e52f6ca43d1617140dc980d42695898a.svg";